






















































import Vue from 'vue';


export default Vue.extend({
  name: 'image-upload',

  watch: {
    error () {
      if (this.error) {
        this.showErrorAlert();
      }
    },

    uploadSuccess () {
      if (this.uploadSuccess) {
        this.showSuccessAlert();
      }
    },
  },

  data () {
    return {
      image: <File | null> null,
      uploading: false,
      imageUrl: '',
      error: false,
      uploadSuccess: false,
      alertCopy: '',
      alertVariant: '',
      showAlert: false,
    };
  },

  methods: {
    clearSelection () {
      this.image = null;
    },

    hideAlert () {
      setTimeout(() => {
        this.showAlert = false;
      }, 5000);
    },

    showSuccessAlert () {
      this.alertCopy = 'Image uploaded successfully';
      this.alertVariant = 'success';
      this.showAlert = true;

      this.hideAlert();
    },

    showErrorAlert () {
      this.alertCopy = 'Error uploading image! Please refresh the page & try again.';
      this.alertVariant = 'danger';
      this.showAlert = true;

      this.hideAlert();
    },

    async onUpload () {
      this.uploading = true;

      const form = new FormData();
      form.append('fileUpload', this.image!);

      const {VUE_APP_ASSET_UPLOAD_API_URL, VUE_APP_GRAPHCMS_ASSET_TOKEN} = process.env;
      const headers = {Authorization: `Bearer ${VUE_APP_GRAPHCMS_ASSET_TOKEN}`};

      await fetch(VUE_APP_ASSET_UPLOAD_API_URL!.toString(), {
        method: 'POST',
        headers,
        body: form,
      }).then(response => {
        this.imageUrl = response.url;
        this.uploading = false;
        this.image = null;
        this.uploadSuccess = true;
      }).then(error => {
        if (error === undefined) {
          this.error = false;
          return;
        }

        this.error = true;
      });
    },
  },
});
